import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'

interface PriceProps {
    children: string
}

const Price: FC<PriceProps> = ({ children }) => {
    return (
        <Typography.Description size="small" font="medium" style={{ color: ColorEnum.GRAY_600 }}>
            {children}
        </Typography.Description>
    )
}

export default Price
